
define('eteration/widgets/ui-mschangepassword',['jquery',
        'knockout',
        'moment',
        'eteration/eteration-ajax',
        'humanize-duration',
        'eteration/eteration-i18n' ,
        'constants/countryregion-constants',
        'eteration/widgets/ui-etrselect',
        'eteration/widgets/ui-dropdownselect',
        'eteration/widgets/ui-selectpicker',
        'eteration/widgets/ui-moment'],

    function($, ko, moment,etrAjax, humanize,  i18n, countryRegionUtil) {

        ko.components.register('mschangepassword', {

            viewModel: function(vm) {
                function PasswordData() {
                    var self = this;
                    self.password = ko.observable();
                    self.repassword = ko.observable();
                    self.oldPassword = ko.observable();
                    self.memberId = ko.observable();
                }

                    var self = this;

                    self.passwordData = ko.observable(new PasswordData());
                    self.wsMessageCode = ko.observable(vm.wsMessageCode);

                    setTimeout(function () {
                        $('[data-bs-toggle="tooltip"]').tooltip({'container': 'body'});
                        $('#oldpassword').attr('type', 'password');
                    }, 700);

                    self.updatePassword = function () {
                        var validationResult = self.validationContext.Validate();
                        if (validationResult.valid) {

                            etrAjax.post({
                                app: 'app.ms',
                                service: '/miles/updatepasswordwithtoken',
                                data: JSON.parse(ko.toJSON(self.passwordData())),
                                callback: function (response) {
                                    self.wsMessageCode(response.data);
                                    $('#updatePasswordMessage').appendTo('body').modal("show");

                                    setTimeout(function () {
                                        self.back();
                                    }, 5000);
                                },
                                uiMap: uiMap
                            });
                        }
                    };

                    self.closeUpdatePasswordModal = function () {
                        $('#updatePasswordMessage').modal("hide");
                    };

                    self.closeChangePasswordModal = function () {
                        $('#changePasswordModal').modal("hide");
                    };


                    var passwordLengthFromAdminQuery = {
                        app: 'app.ms',
                        service: '/miles/passwordlengthfromadmin',
                        disableLoader: true,
                        callback: function (response) {
                            $("#newpassword").attr("maxlength", response.data);
                            $("#repassword").attr("maxlength", response.data);
                        }

                    };
                    etrAjax.get(passwordLengthFromAdminQuery);


                    self.validationContext = ko.jqValidation({
                        customValidators: {
                            passwordRepeatingCharVal: function (el) {
                                if (/(.)\1\1/.test(self.passwordData().password()))
                                    return i18n.get("ERR-MS-MILES-6573");
                            },
                            repasswordControl: function(el) {
                                if( /(.)\1\1/.test(self.passwordData().password()) ) {
                                    return i18n.get("ERR-MS-MILES-6573");
                                }
                                if(self.passwordData().repassword()!=self.passwordData().password()){
                                    return i18n.get("ERR-MS-LOGIN-25");
                                }
                            },
                        },
                        postValidators: [
                            {
                                name: "repassword",
                                id: "repassword",
                                func: function () {
                                    if (self.passwordData().repassword() != self.passwordData().password())
                                        return i18n.get("ERR-MS-LOGIN-25");
                                }
                            },
                            {
                                name: "oldpassword",
                                id: "oldpassword",
                                func: function () {
                                    if (self.passwordData().oldPassword().length < 4 || self.passwordData().oldPassword().length > 6)
                                        return i18n.get("TextField-MS-LOGIN-1000");
                                }
                            },
                            {
                                name: "newpassword",
                                id: "newpassword",
                                func: function () {
                                    if (self.passwordData().password().length != 6)
                                        return i18n.get("ERR-MS-MILES-96");
                                }
                            },
                            {
                                name: "memberId",
                                id: "memberId",
                                func: function () {
                                    if (self.passwordData().memberId().length != 9)
                                        return i18n.get("Error-MS-MS002012101");
                                }
                            }
                        ]
                    });

                    var uiMap = {
                        'passwordData.oldPassword': 'oldpassword',
                        'passwordData.password': 'newpassword',
                        'passwordData.repassword': 'repassword',
                        'passwordData.memberId': 'memberId',
                    };



            },

            template: "<div class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" id=\"changePasswordModal\">\n"+
                "    <div class=\"modal-dialog\">\n"+
                "        <div class=\"modal-content\">\n"+
                "            <button data-bs-dismiss=\"modal\" type=\"button\" class=\"modal-close\" data-bind=\"attr: {title: i18n.get(\'Label-Genel-201\')}\">\n"+
                "                <i class=\"fa fa-times\"></i>\n"+
                "            </button>\n"+
                "            <div data-bind=\"jqValidation: validationContext\">\n"+
                "                <div class=\"card card-primary nomargin animated animated_fadeInUp\">\n"+
                "                    <div class=\"card-header\">\n"+
                "                        <h3 data-bind=\"i18n-text: {  key: \'Label-MS-LOGIN-1002\' , locale: $root.language}\"></h3>\n"+
                "                    </div>\n"+
                "                    <div class=\"card-body\">\n"+
                "                        <form role=\"form\" class=\"form-padding\" autocomplete=\"off\">\n"+
                "                            <div class=\"row\">\n"+
                "                                <div class=\"col-6 warning-container\">\n"+
                "                                    <i class=\"fa fa-md fa-info-circle\"></i>\n"+
                "  	                                 <span data-bind=\"i18n-text: { key: \'Error-MS-MS00201206\'}\"></span>\n"+
                "                                </div>\n"+
                "                            </div>\n"+
                "                            <div class=\"row\" data-bind=\"with : passwordData\">\n"+
                "                                <div class=\"col-12\">\n"+
                "                                    <div class=\"tk-input-field has-feedback has-feedback-lg\">\n"+
                "                                        <label class=\"normal gray\" data-bind=\"i18n-text: { key: \'Label-REF-9\'}\"></label>\n"+
                "                                        <input id=\"memberId\" maxlength=\"9\" class=\"form-control input-large\" data-validation=\'{\"required\":true}\' data-bind=\"value : memberId, number-only\" autocomplete=\"off\" />\n"+
                "                                    </div>\n"+
                "                                    <div class=\"tk-input-field has-feedback has-feedback-lg\">\n"+
                "                                        <label class=\"normal gray\" data-bind=\"i18n-text: { key: \'Label-MS-INFO-60\'}\"></label>\n"+
                "                                        <input id=\"oldpassword\" maxlength=\"6\" class=\"form-control input-large\" data-validation=\'{\"required\":true,\"custom\":\"passwordRepeatingCharVal\"}\' data-bind=\"value : oldPassword, number-only\" autocomplete=\"off\" />\n"+
                "                                    </div>\n"+
                "            \n"+
                "                                    <div class=\"tk-input-field has-feedback has-feedback-lg\">\n"+
                "                                        <label class=\"normal gray dib\" data-bind=\"i18n-text: { key: \'Label-MS-INFO-61\'}\"></label>\n"+
                "                                        <a class=\"no-border dib\" data-bs-toggle=\"tooltip\" data-bind=\"attr:{\'title\':i18n.get( \'TextField-MS-SIGNUP-1000\' )}\" data-bs-placement=\"top\">\n"+
                "                                            <i class=\"fa fa-md fa-info-circle\"></i>\n"+
                "                                        </a>\n"+
                "                                        <input id=\"newpassword\" type=\"password\" class=\"form-control input-large\" data-validation=\'{\"required\":true,\"custom\":\"passwordRepeatingCharVal\"}\' data-bind=\"value : password, number-only\" autocomplete=\"off\"/>\n"+
                "                                    </div>\n"+
                "            \n"+
                "                                    <div class=\"tk-input-field has-feedback has-feedback-lg\">\n"+
                "                                        <label class=\"normal gray\" data-bind=\"i18n-text: { key: \'Label-MS-INFO-62\'}\"></label>\n"+
                "                                        <input id=\"repassword\" type=\"password\" class=\"form-control input-large\" data-validation=\'{\"required\":true,\"custom\":\"passwordRepeatingCharVal\"}\' data-bind=\"value : repassword, number-only\" autocomplete=\"off\"/>\n"+
                "                                    </div>\n"+
                "                                </div>\n"+
                "                            </div>\n"+
                "            \n"+
                "                            <div class=\"w-100 row btn-container\">\n"+
                "                                <div class=\"col-md-3 col-3 mobile-grid-sm-bottom\">\n"+
                "                                    <a class=\"btn btn-outline-secondary btn-lg col-12 bold blue\" data-bind=\"click : closeChangePasswordModal, i18n-text: {  key: \'Label-MS-INFO-889\'}\">\n"+
                "                                        <span>&#171;</span>\n"+
                "                                    </a>\n"+
                "                                </div>\n"+
                "                                <div class=\"col-md-5 col-5 float-end\">\n"+
                "                                    <a class=\"btn btn-danger btn-lg col-12 bold\" data-bind=\"click : updatePassword,  i18n-text: {key: \'Label-MS-INFO-70\'}\"></a>\n"+
                "                                </div>\n"+
                "                            </div>\n"+
                "                        </form>\n"+
                "                    </div>\n"+
                "                </div>\n"+
                "            </div>\n"+
                "        </div>\n"+
                "    </div>\n"+
                "</div>\n"+
                ""

        });

    });
